<template>
  <div class="bg-white px-4 lg:px-12 sticky top-0 z-10 border-b">
    <nav class="text-sm max-w-7xl mx-auto flex whitespace-nowrap overflow-y-auto">
      <RouterLink
        v-for="item in navigation"
        :key="item.label"
        :to="item.route"
        class="px-4 inline-flex h-12 items-center justify-center"
        :class="[
          $route.name === item.route.name
            ? 'text-blue-600 bg-gray-200'
            : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
        ]"
      >
        {{ item.label }}
      </RouterLink>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PackageTabbedMenu',
  props: {
    isPackage: Boolean,
  },
  computed: {
    navigation() {
      const navigationItems = [
        {
          label: this.$t('global.general'),
          permissions: null,
          route: { name: 'admin.products.packages.package' },
        },
        {
          label: this.$t('global.packageItems'),
          permissions: null,
          route: { name: 'admin.products.packages.package.packageItems' },
        },
        {
          label: this.$t('global.packageEditions'),
          permissions: null,
          route: { name: 'admin.products.packages.package.packageEditions' },
        },
        {
          label: this.$t('global.subscriptionPlans'),
          permissions: null,
          route: { name: 'admin.products.packages.package.subscriptionPlans' },
        },
        {
          label: this.$t('global.projects'),
          permissions: null,
          route: { name: 'admin.products.packages.package.projects' },
        },
      ];

      return navigationItems
        .filter((item) => {
          if (!item.permissions) {
            return true;
          }

          return this.$membershipHasPermissionTo(item.permissions);
        })
        .map((item) => ({
          label: item.label,
          route: item.route,
        }));
    },
  },
};
</script>

<style></style>
